import React from "react"
import { graphql } from "gatsby"
import IntroTextoInicio from "./IntroTextoInicio"
import IntroVideoInicio from "./IntroVideoInicio"

/*
 * El intro ahora lo manda el CMS (pestaña Intro del template Inicio):
 *
 *   visualizar_intro -> prende o apaga la sección completa
 *   estilo_intro     -> "estilo1" (texto e imágenes) o "estilo2" (video)
 *
 * Cada estilo tiene sus propios campos y su propia línea de tiempo, así que
 * vive en su archivo; acá solo se elige cuál se monta. El switch va afuera de
 * los componentes a propósito: los dos bloquean el scroll y corren timers en
 * useEffect, y así el que no se usa nunca llega a montarse.
 */

const ESTILO_VIDEO = "estilo2"

export default function IntroInicio({
  visualizar,
  estilo,
  imagen,
  imagenMobile,
  colorFondo,
  colorTexto,
  titulo,
  autor,
  videoDesktop,
  videoMobile,
}) {
  if (!visualizar) return null

  if (estilo === ESTILO_VIDEO) {
    return (
      <IntroVideoInicio videoDesktop={videoDesktop} videoMobile={videoMobile} />
    )
  }

  return (
    <IntroTextoInicio
      imagen={imagen}
      imagenMobile={imagenMobile}
      colorFondo={colorFondo}
      colorTexto={colorTexto}
      titulo={titulo}
      autor={autor}
    />
  )
}

export const queryIntroInicio = graphql`
  fragment introInicio on Wordpress_Template_Inicio_Inicio {
    visualizarIntro
    estiloIntro
    imagenIntro {
      ...imagen
    }
    imagenIntroMobile {
      ...imagen
    }
    colorFondoIntro
    colorTextoIntro
    tituloIntro
    autorIntro
    videoDesktopIntro {
      mediaItemUrl
      mimeType
    }
    videoMobileIntro {
      mediaItemUrl
      mimeType
    }
  }
`
